/* ==========================================================================
   Olfatto v2 — secciones fijas
   IntersectionObserver, sin listener de scroll y sin loop de rAF propio,
   para no competir con Lenis.
   Si esto falla, la sección se lee igual: solo deja de actualizarse el
   contador. Ningún contenido depende de este script para ser visible.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    var steps = root.querySelectorAll('[data-olf-sticky-step]');
    var out = root.querySelector('[data-olf-sticky-current]');
    if (!steps.length || !out || !('IntersectionObserver' in window)) return;

    var visible = new Set();

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var n = e.target.getAttribute('data-olf-sticky-step');
          if (e.isIntersecting) visible.add(n);
          else visible.delete(n);
          e.target.classList.toggle('is-active', e.isIntersecting);
        });

        if (visible.size) {
          var first = Array.from(visible)
            .map(Number)
            .sort(function (a, b) {
              return a - b;
            })[0];
          out.textContent = first;
        }
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    steps.forEach(function (s) {
      io.observe(s);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-olf-sticky]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () {
    boot();
  });

  /* el editor de temas recarga secciones sin recargar la página */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
